export default {
  meta: {
    title: $localize`:@@meta.wheel.home.title1:CS2 Колесо Фортуны & Рулетка CSGO`,
    description: $localize`:@@meta.wheel.home.desc:Испытайте удачу с Колесом Фортуны в CS2 на CSFAIL. Вращайте колесо и выигрывайте ценные призы, наслаждаясь азартом и уникальными возможностями.`
  }
};